import {Button, Container, Stack, Typography} from '@mui/material';
import React from 'react';
import {useSelector} from 'react-redux';
import Logo from 'src/components/Logo';
import {isNullOrEmpty} from 'src/utils/helperMethods';
import {redirectToWhatsUp} from 'src/utils/links';
import AutoRenewalForm from './AutoRenewalForm';
import {isFeatureAllowed} from 'src/utils/featureUtils';
import useUser from 'src/hooks/useUser';

export default function PaymentDuePage() {
	const {subscription = 'free'} = useSelector((state) => state.admin.user.OwnedWebsite);
	const {user} = useUser();

	const onClick = () => {
		redirectToWhatsUp();
	};

	return (
		<div
			style={{
				// margin: 0,
				height: '100vh',
				width: '100vw',
				backgroundSize: 'cover',
				backgroundImage: `url("/static/backgrounds/gradientwavebackground.png")`,
				backgroundRepeat: 'no-repeat',
			}}
		>
			<Container>
				<Stack height="80vh" pt={4} alignItems="center" justifyContent="center">
					<Logo />
					<Stack mt={4} spacing={2} alignItems="center">
						<Typography variant="h5"> انتهت الفترة المحددة لدفع قيمة الاشتراك </Typography>
						<Typography variant="body1">
							للاستمرار في استخدام منصة فترينا يرجي التواصل معنا لتسديد قيمة الاشتراك
						</Typography>
					</Stack>

					<Button onClick={onClick} size="medium" sx={{my: 2, px: 4, py: 1.2}} variant="contained">
						تواصل معنا
					</Button>
				</Stack>
			</Container>
		</div>
	);
}
